import React, { useState } from "react";
import { PageTabs } from "@velaro/velaro-component-lib";
import { SectionCard } from "@/components/ds";
import NetSuiteDataMapping from "./NetSuiteDataMapping";
import IntegrationActivityLog from "../IntegrationActivityLog";

interface Props {
  teamId: number;
  selectedConfigId: number;
}

export default function NetsuiteTabs(props: Props) {
  const [activeTab, setActiveTab] = useState("Data Mapping");

  return (
    <SectionCard className="mb-4">
      <PageTabs
        tabs={["Data Mapping", "Logs"]}
        activeTab={activeTab}
        onChange={setActiveTab}
      />
      <div className="pt-4">
        {activeTab === "Data Mapping" ? (
          <NetSuiteDataMapping
            teamId={props.teamId}
            selectedConfigId={props.selectedConfigId}
          />
        ) : (
          <IntegrationActivityLog integrationSlug="NetSuite" />
        )}
      </div>
    </SectionCard>
  );
}
